<img src="../../../assets/img/logo-original-01.svg" width="300px" height="180px">

<div class="login">
    <div class="login-triangle"></div>
    <h2 class="login-header">Log in</h2>

    <form class="login-container" (ngSubmit)="onLogin()" [formGroup]="loginForm">
        <div class="form-group">
            <p><input style="text-transform:uppercase" class="form-control" type="text" autocomplete="off" formControlName="usuario"></p>
        </div>
        <div class="form-group ">
            <p><input class="form-control" type="password" autocomplete="off" formControlName="clave"></p>
        </div>
        <p><button class="btn btn-warning btn-lg btn-block" type="submit">Ingresar</button></p>
    </form>
</div>